export default function Trust() {
  const trustPoints = [
    {
      icon: 'ri-shield-check-line',
      title: 'Datos Protegidos',
      description: 'Tu información personal y financiera está protegida con los más altos estándares de seguridad y confidencialidad.'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Procesos Claros',
      description: 'Transparencia total en cada paso. Sabrás exactamente qué estamos haciendo, por qué y cuáles son los costos involucrados.'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Acompañamiento Real',
      description: 'No te dejamos solo después de conseguir el capital. Te acompañamos en la estrategia de uso y mantenimiento de tu perfil.'
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Ética Profesional',
      description: 'Trabajamos con integridad y honestidad. Si tu perfil no está listo, te lo diremos y te ayudaremos a prepararlo primero.'
    }
  ];

  return (
    <section className="py-24 bg-[#050505] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-full">
        <div className="absolute top-20 right-20 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#D4AF37]/5 rounded-full blur-3xl"></div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Trabaja con <span className="text-[#D4AF37]">Confianza</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Tu tranquilidad y éxito son nuestra prioridad
          </p>
          <div className="w-24 h-1 bg-[#D4AF37] mx-auto mt-6"></div>
        </div>

        {/* Sección de fundadores */}
        <div className="mb-20 max-w-5xl mx-auto">
          <div className="bg-gradient-to-br from-[#1C1C1C] to-[#1C1C1C]/50 p-10 md:p-12 rounded-2xl border border-[#D4AF37]/30 shadow-2xl">
            <div className="flex flex-col md:flex-row items-center gap-10">
              <div className="w-full md:w-2/5 flex-shrink-0">
                <div className="relative">
                  <div className="absolute -inset-4 bg-gradient-to-r from-[#D4AF37]/20 to-[#F4D03F]/20 rounded-2xl blur-xl"></div>
                  <img 
                    src="/IMG_94370880.webp" 
                    alt="Ariel y Fior - Fundadores de Cashflow VIP" 
                    className="relative rounded-xl w-full h-auto object-cover shadow-2xl border-2 border-[#D4AF37]/30"
                  />
                </div>
              </div>
              <div className="flex-1 text-center md:text-left">
                <div className="mb-4">
                  <span className="inline-block px-4 py-2 bg-[#D4AF37]/10 border border-[#D4AF37]/30 rounded-full text-[#D4AF37] text-sm font-semibold">
                    Nuestros Fundadores
                  </span>
                </div>
                <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                  Ariel y Fior
                </h3>
                <p className="text-xl text-[#D4AF37] font-semibold mb-6">
                  Expertos en Crédito y Fundadores de Cashflow VIP
                </p>
                <p className="text-gray-300 leading-relaxed mb-6">
                  Con años de experiencia en el sector financiero, Ariel y Fior han ayudado a cientos de personas y negocios a transformar su perfil crediticio y acceder al capital que necesitan para crecer.
                </p>
                <p className="text-gray-400 leading-relaxed">
                  Su enfoque personalizado, ético y basado en resultados reales ha convertido a Cashflow VIP en la opción preferida para quienes buscan soluciones financieras profesionales y confiables.
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {trustPoints.map((point, index) => (
            <div
              key={index}
              className="bg-[#1C1C1C] p-8 rounded-xl border border-[#D4AF37]/20 hover:border-[#D4AF37] transition-all duration-300 text-center group hover:transform hover:scale-105"
            >
              <div className="w-20 h-20 bg-gradient-to-br from-[#D4AF37]/20 to-[#D4AF37]/5 rounded-full flex items-center justify-center mx-auto mb-6 group-hover:from-[#D4AF37] group-hover:to-[#F4D03F] transition-all duration-300">
                <i className={`${point.icon} text-[#D4AF37] group-hover:text-[#050505] text-3xl transition-colors duration-300`}></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-4">
                {point.title}
              </h3>
              <p className="text-gray-400 leading-relaxed">
                {point.description}
              </p>
            </div>
          ))}
        </div>

        {/* Sección adicional de garantía */}
        <div className="mt-16 max-w-4xl mx-auto">
          <div className="bg-gradient-to-r from-[#1C1C1C] to-[#1C1C1C]/50 p-10 rounded-2xl border border-[#D4AF37]/30">
            <div className="flex flex-col md:flex-row items-center gap-6">
              <div className="w-24 h-24 bg-[#D4AF37] rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-verified-badge-line text-[#050505] text-4xl"></i>
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="text-2xl font-bold text-white mb-3">
                  Compromiso con tu Éxito
                </h3>
                <p className="text-gray-300 leading-relaxed">
                  En Cashflow VIP, tu éxito es nuestro éxito. Trabajamos con dedicación, profesionalismo y transparencia para ayudarte a alcanzar tus metas financieras. No prometemos milagros, pero sí resultados reales basados en estrategias probadas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
